import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const PostbackJSSettingsView = React.lazy(() => import("./Postback.view"));

const PostbackLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <PostbackJSSettingsView />
  </React.Suspense>
);
export default () => <PostbackLoadable />;
